import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
import React, { useState, useEffect, useCallback } from 'react';
import RangeField from '../range-field/RangeField';
import * as styles from './Range.style';
export let RangeControlType = /*#__PURE__*/function (RangeControlType) {
  RangeControlType["MIN"] = "min";
  RangeControlType["MAX"] = "max";
  return RangeControlType;
}({});
const minInputStyle = {
  borderRadius: '.3rem 0 0 .3rem',
  flexGrow: 1
};
const maxInputStyle = {
  borderRadius: '0 .3rem .3rem 0',
  flexGrow: 1,
  marginLeft: '-1px',
  width: 'calc(100% + 1px)'
};
export function Range(_ref) {
  let {
    minName,
    maxName,
    dataRef = 'range',
    icon,
    disabled,
    loading,
    minValue,
    maxValue,
    minError,
    maxError,
    minPlaceholder,
    maxPlaceholder,
    maxVisibleSuggestions,
    onChange,
    onBlur,
    onFocus,
    printValue,
    maxSuggestions,
    minSuggestions,
    printSuggestion,
    onSuggestionSelected,
    onMinGreaterThanMax
  } = _ref;
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [currentControlType, setCurrentControlType] = useState();
  const [maxInputElement, setMaxInputElement] = useState();
  useEffect(() => {
    if (onMinGreaterThanMax && minValue && maxValue && parseInt(minValue, 10) > parseInt(maxValue, 10)) {
      onMinGreaterThanMax(minValue, maxValue);
    }
  }, [minValue, maxValue, onMinGreaterThanMax]);
  const onInternalFocus = useCallback(controlType => e => {
    setCurrentControlType(controlType);
    if (onFocus) {
      onFocus(e);
    }
  }, [onFocus]);
  const maxInputRef = useCallback(input => {
    setMaxInputElement(input);
    return input;
  }, []);
  const onInternalSuggestionSelected = useCallback(controlType => suggestion => {
    // Focus on max input when min input is filled by a suggestion
    if (controlType === RangeControlType.MIN && maxInputElement) {
      maxInputElement.focus();
    }
    if (onSuggestionSelected) {
      onSuggestionSelected(suggestion, controlType);
    }
  }, [maxInputElement, onSuggestionSelected]);
  const onSuggestionsVisibilityChange = useCallback(visibility => {
    setShowSuggestions(visibility);
  }, []);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-ref": dataRef,
    $_css: styles.basic
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $zIndex: minError ? '1' : 'initial',
    $_css2: styles.box
  }, /*#__PURE__*/React.createElement(RangeField, {
    dataRef: dataRef && `${dataRef}-${RangeControlType.MIN}`,
    name: minName,
    value: minValue,
    "aria-label": "Campo per inserire il valore minimo",
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onInternalFocus(RangeControlType.MIN),
    style: {
      input: showSuggestions && currentControlType === RangeControlType.MIN ? {
        ...minInputStyle,
        borderRadius: '.3rem 0 0 0'
      } : minInputStyle
    },
    icon: icon,
    error: minError,
    loading: loading,
    disabled: disabled,
    placeholder: minPlaceholder || 'Min',
    printValue: printValue,
    printSuggestion: printSuggestion,
    suggestions: minSuggestions,
    maxVisibleSuggestions: maxVisibleSuggestions,
    onSuggestionSelected: onInternalSuggestionSelected(RangeControlType.MIN),
    onSuggestionsVisibilityChange: onSuggestionsVisibilityChange
  })), /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css3: styles.box
  }, /*#__PURE__*/React.createElement(RangeField, {
    dataRef: dataRef && `${dataRef}-${RangeControlType.MAX}`,
    name: maxName,
    forwardedRef: maxInputRef,
    value: maxValue,
    "aria-label": "Campo per inserire il valore massimo",
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onInternalFocus(RangeControlType.MAX),
    style: {
      input: showSuggestions && currentControlType === RangeControlType.MAX ? {
        ...maxInputStyle,
        borderRadius: '0 .3rem 0 0'
      } : maxInputStyle,
      suggestions: {
        width: 'calc(100% + 1px)',
        marginLeft: '-1px'
      }
    },
    icon: icon,
    error: maxError,
    loading: loading,
    disabled: disabled,
    placeholder: maxPlaceholder || 'Max',
    printValue: printValue,
    printSuggestion: printSuggestion,
    suggestions: maxSuggestions,
    maxVisibleSuggestions: maxVisibleSuggestions,
    onSuggestionSelected: onInternalSuggestionSelected(RangeControlType.MAX),
    onSuggestionsVisibilityChange: onSuggestionsVisibilityChange
  })));
}
export default Range;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Range___StyledDiv",
  componentId: "sc-1xw5b-0"
})(["", ""], p => p.$_css);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "Range___StyledDiv2",
  componentId: "sc-1xw5b-1"
})(["", ""], p => p.$_css2);
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "Range___StyledDiv3",
  componentId: "sc-1xw5b-2"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=Range.js.map